import router from "../../router";
import IbonazzService from "@/services/ibonazz-service";


/*** Products */
export function loadTerminalList({ commit }, payload) {
    IbonazzService.getTerminalList(payload).then(response => {
        commit("_setTerminalListArray", response.data);
    })
    .catch(e => {
        console.log(e);
    });
}


export function openTerminal({ commit, getters }, payload) {
  return new Promise((resolve, reject) => {
  IbonazzService.openTerminal(payload).then(response => {
                   resolve("true");
        })
        .catch(error => {
          console.log(error);
          reject(error)
          //reject(error)
        });
      })

}

export function closeTerminal({ commit, getters }, payload) {
  return new Promise((resolve, reject) => {
  IbonazzService.closeTerminal(payload).then(response => {
                   resolve("true");
        })
        .catch(error => {
          console.log(error);
          reject(error)
          //reject(error)
        });
      })

}
